import { Component } from "react";
import { connect } from "react-redux";
import { IStore } from "../DataTypes/storeTypes";
import NavigationBar from "./NavigationBar";
import { ModalWrapper } from "./ModalWrapper";

interface IProps {}

class Main extends Component<IProps> {
    render() {
        return (
            <>
                <NavigationBar />
                <ModalWrapper />
            </>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: IProps): IProps => {
    return {
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch, ownProps: IProps): IProps => {
    return {
        ...ownProps,
    };
};

export const MainConnected = connect(mapStateToProps, mapDispatchToProps)(Main);
